import React, { useState, useEffect } from "react";
import createPrivateAdminPanelInstance from "../../../../../../api/PrivateAdminPanelInstance";

import "./stylesManualPassPopup.css";
import { API_ROUTES } from "../../../../../../api/ApiRoutes";
import { CloseOutlined } from "@ant-design/icons";
import { message } from "antd";

function ManualPassPopup({
  onClosePressed,
  selectedAdmin,
  selectedChallengeId,
  selectedTask,
  initialBetId,
  initialReason,
  weeklyChallengesData,
  onUpdateSuccess,
}) {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const [reason, setReason] = useState(initialReason || "");
  const [betId, setBetId] = useState(initialBetId || "");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Reset state when modal reopens with new props
  useEffect(() => {
    setReason(initialReason || "");
    setBetId(initialBetId || "");
    setIsSubmitting(false);
  }, [initialReason, initialBetId]);

  const buttonDisabled = reason.length <= 0 ? true : false;

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    const params = {
      reason: reason,
      user_id: selectedAdmin.user_id,
      challenge_id: selectedChallengeId,
      task_index: selectedTask.task_index,
      league_name: weeklyChallengesData.name,
      bet_id: betId,
    };
    
    console.log("params", params);

    // return;

    try {
      await PrivateAdminPanelInstance?.post(
        API_ROUTES?.EDIT_TASK,
        params
      );
      message.success("Manual pass user added successfully!");

      // Update local data without refetching
      if (onUpdateSuccess) {
        onUpdateSuccess(selectedChallengeId, selectedTask.task_index, reason, betId);
      }

      setReason("");
      handleClosePressed();
    } catch (error) {
      console.log("Error adding manual pass user:", error);
      message.error("Error adding manual pass user. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClosePressed = () => {
    onClosePressed();
    setReason("");
    setBetId("");
    setIsSubmitting(false);
  };

  return (
    <div className="manual-pass-popup">
      <div className="manual-pass-panel">
        <div className="modal-header">
          <div className="modal-header-title">
            <h2 className="modal-title">Manual Pass User</h2>
          </div>
          <CloseOutlined onClick={handleClosePressed} className="close-icon" />
        </div>

        <div className="divider" />

        <form onSubmit={handleSubmit}>
          <div className="reason-input-container">
            <label htmlFor="reason">Reason*</label>
            <textarea
              type="text"
              id="reason"
              value={reason}
              maxLength={50}
              rows={3}
              placeholder="Leave a comment"
              onChange={(e) => setReason(e.target.value)}
              required
            />
            <span className="manual-pass-max-length">{reason.length}/50</span>
          </div>

          <div className="bet-id-input-container">
            <label htmlFor="bet-id">Bet ID</label>
            <input
              type="text"
              id="bet-id"
              value={betId || ""}
              onChange={(e) => setBetId(e.target.value)}
            />
          </div>

          <div className="modal-footer">
            <button className="cancel-button" onClick={handleClosePressed}>
              Cancel
            </button>
            <button
              type="submit"
              disabled={buttonDisabled}
              className={`submit-button ${
                buttonDisabled || isSubmitting ? "disabled" : null
              }`}
            >
              {isSubmitting ? "Adding Manual Pass..." : "Manual Pass"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ManualPassPopup;
